import { LogLevel } from "@azure/msal-browser";
export const msalConfig = {
    auth: {
        tenantId: process.env.REACT_APP_SUMMIT_TENANT_ID ?? "", //?? "832b9883-a6b8-4596-ad81-842f429d053e",
        clientId: process.env.REACT_APP_SUMMIT_APP_CLIENT_ID ?? "", //?? '69f02294-7096-4ad3-ac9e-5d0a8a13335f',
        authority: process.env.REACT_APP_SUMMIT_AUTHORITY ?? "", // 'https://login.microsoftonline.com/832b9883-a6b8-4596-ad81-842f429d053e', 
        redirectUri: process.env.REACT_APP_SUMMIT_LOGIN_REDIRECT_URL ?? "", //'http://localhost:3002',
        postLogoutRedirectUri: process.env.REACT_APP_SUMMIT_LOGOUT_REDIRECT_URL ?? "", // "/",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: process.env.REACT_APP_SUMMIT_CACHE_LOCATION ?? "", // "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
          // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
          loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
              return;
            }
            switch (level) {
              case LogLevel.Error:
                console.error(message);
                return;
              case LogLevel.Info:
                console.info(message);
                return;
              case LogLevel.Verbose:
                console.debug(message);
                return;
              case LogLevel.Warning:
                console.warn(message);
                return;
            }
          },
        },
      },
    };

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginScopes = {
    scopes: [
        'user.read', 'openid', 'profile'
      ] 
};

export const apiAccessScopes = {
    scopes: [
        process.env.REACT_APP_SUMMIT_API_ACCESS_TOKEN_SCOPE ?? ''
    ]
};
